import type { IPersonData } from './person-data.model';

export default interface IContactInformation extends IPersonData {
  phoneNumber: string;
  email: string;
}

export const emptyContactInformation: IContactInformation = {
  valid: false,
  personalIdentityNumber: '',
  firstName: '',
  lastName: '',
  address: {
    careOf: '',
    streetAddress: '',
    postalCode: '',
    city: '',
    country: '',
  },
  phoneNumber: '',
  email: '',
};
